<template>
<transition name="fade-popup">
    <div class="incoming-orders__overlay" v-if="showLabelPopup">
    <div class="incoming-orders__popup" v-if="isLoading">
    <h4>{{$t('Creating your labels...')}}</h4>
    </div>
    <div class="incoming-orders__popup" v-if="!isLoading && !isShowLabels">
    <h4 class="incoming-orders___heading">{{$t('Your labels are ready!')}}</h4>
    <b-button class="incoming-orders__button incoming-orders__download-button" variant="primary" @click="showLabels">
    <font-awesome-icon icon="file-alt"/>
    {{$t('Download label')}}</b-button>
    </div>
    <div class="incoming-orders__labels-wrap" v-if="isShowLabels">
    <div class="incoming-orders__label" v-if="isShowLabels">
    <ShippingLabel :name="orders[activeOrderIndex || 0].customer.name" :carrier="orders[activeOrderIndex || 0].carrier" :country="orders[activeOrderIndex || 0].customer.country ? orders[activeOrderIndex || 0].customer.country.name : orders[activeOrderIndex || 0].country.name"/>
    </div>
    <div class="incoming-orders__label">
    <ShippingLabel :name="orders[1].customer.name" :carrier="orders[1].carrier" :country="orders[1].country"/>
    </div>
    <div class="incoming-orders__label">
    <ShippingLabel :name="orders[2].customer.name" :carrier="orders[2].carrier" :country="orders[2].country"/>
    </div>
    </div>
    <b-button class="incoming-orders__button incoming-orders__reset-button" @click="replay" v-if="isShowLabels && !isLoading">
    <font-awesome-icon icon="sync"/>
    {{$t('Replay this demo')}}</b-button>
    </div>
</transition>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import ShippingLabel from "@/components/Shipping/ShippingLabel.vue"

export default {
    name: 'ShippingLabelPopup',
    components: {
        BButton,
        ShippingLabel
    },
    props: ['activeOrderIndex', 'orders', 'isLoading', 'showPopup', 'showLabelPopup', 'isShowLabels', 'showLabels', 'replay']
}
</script>

<style scoped>
.fade-popup-enter, .fade-popup-leave-to
/* .fade-popup-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-popup-leave-active {
    position: absolute;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.incoming-orders__overlay {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.0);
    z-index: 1;
    transition: opacity 0.2s;
}

.incoming-orders__popup {
    flex-direction: column;
    width: 450px;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: white;
    border-radius: 10px;
    box-shadow: 0px 3px 79px 0px rgba(0, 0, 0, 0.23);
}

.incoming-orders__download-button {
    background: var(--sky-blue);
    border: 1px solid var(--sky-blue);
}

.incoming-orders__labels-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 550px;
    height: 600px;
}

.incoming-orders___heading {
    margin-bottom: 15px;
}

.incoming-orders__label {
    transform-origin: 0% 100%;
    position: absolute;
    top: 0;
}

.incoming-orders__label:nth-child(1) {
    transform: rotate(-5deg);
    z-index: 1;
}

.incoming-orders__label:nth-child(2) {
    transform: rotate(5deg);
    z-index: -1;
}
</style>